import React, { useContext } from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/pro-duotone-svg-icons'
import { KeDoContext } from '../../../kedo-context'
import { LoadingProps } from './loading.types'
import { getPixelSize } from './loadingUtils'

const LoadingPage: React.FC<LoadingProps> = ({ size = 'md', message }) => {
    const kedo = useContext(KeDoContext)
    const pixelSize = getPixelSize(size)

    return (
        <Grid container justifyContent="center" alignItems="center">
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    className="loading loadingPage"
                >
                    <Box sx={{ textAlign: 'center' }}>
                        <FontAwesomeIcon
                            icon={faCircleNotch}
                            spin
                            role="status"
                            aria-hidden="true"
                            style={{
                                ...(pixelSize ? { fontSize: pixelSize } : {}),
                                animationDuration: '1.25s',
                            }}
                            size={pixelSize ? undefined : (size as any)}
                        />
                    </Box>
                    <Box mt={3} />
                    <Typography variant="body1">
                        {message
                            ? kedo.t(message)
                            : kedo.t('Busy fetching the page') + '...'}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}

export default LoadingPage
